import { render, staticRenderFns } from "./PaymentMeans.vue?vue&type=template&id=6880af07&"
import script from "./PaymentMeans.vue?vue&type=script&lang=js&"
export * from "./PaymentMeans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports